import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=d9578a2a&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=d9578a2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9578a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9578a2a')) {
      api.createRecord('d9578a2a', component.options)
    } else {
      api.reload('d9578a2a', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=d9578a2a&scoped=true", function () {
      api.rerender('d9578a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/orderDetail.vue"
export default component.exports